(function () {
  'use strict';

  var _controller = null;
  var _autoTimer  = null;
  var _syncTimer  = null;

  function init() {

    if (_controller) _controller.abort();
    clearInterval(_autoTimer);
    clearTimeout(_syncTimer);
    _autoTimer = null;
    _syncTimer  = null;
    _controller = new AbortController();
    var sig = { signal: _controller.signal };

    var track   = document.getElementById('carousel-track');
    var prevBtn = document.getElementById('carousel-prev');
    var nextBtn = document.getElementById('carousel-next');
    if (!track || !prevBtn || !nextBtn) return;

    var GAP       = 28;
    var cardIndex = 0;

    function step() {
      var card = track.querySelector('.product-card');
      return card ? card.offsetWidth + GAP : 278;
    }

    function maxIndex() {
      return Math.floor((track.scrollWidth - track.clientWidth) / step());
    }

    function goTo(index, instant) {
      var s   = step();
      var max = maxIndex();

      if (index > max) {
        cardIndex = 0;
      } else if (index < 0) {
        cardIndex = max;
      } else {
        cardIndex = index;
      }

      var target = (cardIndex >= max)
        ? track.scrollWidth - track.clientWidth
        : cardIndex * s;

      if (instant) {
        track.style.scrollBehavior = 'auto';
        track.scrollLeft = target;
        requestAnimationFrame(function() {
          requestAnimationFrame(function() {
            track.style.scrollBehavior = '';
          });
        });
      } else {
        track.scrollTo({ left: target, behavior: 'smooth' });
      }

      updateArrows();
    }

    function updateArrows() {
      prevBtn.disabled = false;
      nextBtn.disabled = false;
    }

    function syncFromScroll() {
      var s        = step();
      var newIndex = Math.max(0, Math.min(Math.round(track.scrollLeft / s), maxIndex()));
      if (newIndex !== cardIndex) {
        cardIndex = newIndex;
        updateArrows();
      }
    }

    function tick() {
      if (!document.body.contains(track)) {
        stopAuto();
        return;
      }
      if (cardIndex >= maxIndex()) {
        goTo(0, false);
      } else {
        goTo(cardIndex + 1, false);
      }
    }

    function startAuto() {
      if (_autoTimer) return;
      _autoTimer = setInterval(tick, 3000);
    }

    function stopAuto() {
      clearInterval(_autoTimer);
      _autoTimer = null;
    }

    prevBtn.addEventListener('click', function() { goTo(cardIndex - 1); }, sig);
    nextBtn.addEventListener('click', function() { goTo(cardIndex + 1); }, sig);

    track.addEventListener('mouseenter', stopAuto, sig);
    track.addEventListener('mouseleave', startAuto, sig);
    track.addEventListener('touchstart', stopAuto,  { passive: true, signal: _controller.signal });
    track.addEventListener('touchend',   startAuto, { passive: true, signal: _controller.signal });

    [prevBtn, nextBtn].forEach(function(btn) {
      btn.addEventListener('mouseenter', stopAuto, sig);
      btn.addEventListener('mouseleave', startAuto, sig);
    });

    track.addEventListener('keydown', function(e) {
      if (e.key === 'ArrowLeft')  { e.preventDefault(); goTo(cardIndex - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(cardIndex + 1); }
    }, sig);

    if ('onscrollend' in window) {
      track.addEventListener('scrollend', syncFromScroll, { passive: true, signal: _controller.signal });
    } else {
      track.addEventListener('scroll', function() {
        clearTimeout(_syncTimer);
        _syncTimer = setTimeout(syncFromScroll, 120);
      }, { passive: true, signal: _controller.signal });
    }

    updateArrows();
    startAuto();
  }

  window.initCarousel = init;
  init();

})();
